<template>
  <div>
    <!--
    <s-search-staff-muti
      v-model="form.ccStaffs"
      outlined
      dense
      hide-details
      label="副本"
      class="mb-1"
    />
    -->
    <!-- 附件 -->
    <v-checkbox
      v-if="prefillInfo && (prefillInfo.prefilledInstruction || prefillInfo.preFilledReceiverTOList.length)"
      v-model="isAgreeInstruction"
      :label="$t('eDocSuggest.agreeInstruction')"
      @click="clickAgreeInstructionHandler"
    />

    <v-form
      ref="eDocForm"
      @submit.prevent="submit"
    >
      <div
        v-if="prefillInfo"
        class="mb-1"
      >
        <s-attachment-list
          :process-id="edoc.dfProcessId"
          :file-list="prefillInfo.fileList"
          :pass-file-list.sync="forwardedOrDeletedFiles"
        />
      </div>
      <div
        v-if="!openerList || openerList.length === 0"
        class="mb-2"
      >
        <s-file-uploader-box-style
          ref="attachUploader"
          multiple
          :post-url="uploadFileUrl"
          extensions=""
          accept=""
          :maximum="10"
          use-attachment-icon
          :response.sync="attachDocResponse"
          :label="$t('eDocInternal.additionalFile')"
          @uploadError="onUploadError"
        />
      </div>
      <v-btn
        v-for="(cannedMsg, index) in DOC_FLOW_CANNED_MSG_I18NS"
        :key="index"
        depressed
        rounded
        class="mb-2 mr-2"
        @click="appendMsgToInstructionContent($t(cannedMsg))"
      >
        {{ $t(cannedMsg) }}
      </v-btn>
      <v-textarea
        v-model="form.senderInstruction"
        :label="$t('DocFlow.Instruction') + ' / ' + $t('DocFlow.Instruction.B')"
        rows="3"
        outlined
        hide-details
      />
      <div class="caption grey--text text--darken-1 mb-4">
        {{ $t('eDocSuggest.hint.instructionWillBeRecorded') }}
      </div>
      <s-add-encrypted-staff
        v-if="openerList && openerList.length && isMeOpener"
        :opener-list="openerList"
        :new-openers-euid.sync="newOpenersEuid"
        :new-openers-obj.sync="newOpenersObj"
      />
      <div>
        <s-search-staff-muti
          v-model="euids"
          :label="$t('eDocSuggest.history.receiver')"
          :rules="rules.requiredField"
          show-group
          @dataChange="receiverToList = $event"
        />
        <!-- {{ receiverToList }} -->
      </div>
      <div class="d-flex mt-2">
        <v-spacer />
        <v-btn
          :loading="loading"
          class="primary"
          @click="submit"
        >
          {{ $t('ConfirmModal.OK') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>

import SSearchStaffMuti from '@/components/SSearchStaffMuti'
import SAddEncryptedStaff from './SAddEncryptedStaff.vue'
import SFileUploaderBoxStyle from '@/components/SFileUploaderBoxStyle'
import docFlowApi from '@/api/eDocInternal/docFlow'
// import { breakSubErrors } from '@/utils/messageUtil'
import { globalModule } from '@/store/moduleName'
import VuetifyJetValidator from 'vuetify-jet-validator'
import { uploadMethod } from '@/mixins/uploadMethod'
import { DOC_FLOW_ACTION_TYPE, DOC_FLOW_CANNED_MSG_I18NS } from '@/constant/constant'
import { mdiFileDocumentOutline, mdiMenuDown, mdiClose } from '@mdi/js'
// import { buildStaffList } from '@/utils/utils'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import SAttachmentList from './SAttachmentList'
import messageUtil from '@/utils/messageUtil'
import { encryptMethod } from '@/mixins/encryptMethod'

export default {
  components: {
    SSearchStaffMuti,
    SFileUploaderBoxStyle,
    SAttachmentList,
    SAddEncryptedStaff
  },
  mixins: [uploadMethod, docFlowMethod, encryptMethod],
  props: {
    edoc: {
      type: Object,
      default: null
    },
    uploadFileUrl: {
      type: String,
      default: null
    },
    docFlowStatus: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      mdiClose: mdiClose,
      mdiMenuDown: mdiMenuDown,
      mdiFileDocumentOutline: mdiFileDocumentOutline,
      isAgreeInstruction: false,
      form: {
        processAttachmentList: [],
        dfProcessId: null,
        receiverTOList: [],
        receiverCCList: [],
        prefilledInstruction: null,
        preFilledReceiverTOList: [],
        preFilledReceiverCCList: [],
        prefilledNote: null,
        senderInstruction: null,
        senderNote: null,
        oriStatusCode: null
      },
      isShowPrivateMsg: false,
      privateMsgDialog: false,
      docTypes: [],
      // uploadFileUrl: null,
      attachDocResponse: [],
      preAttachDoc: [],
      loading: false,
      euids: [],
      receiverToList: [],
      prefilledContent: {
        toStaffs: [],
        ccStaffs: [],
        mainContent: null
      },
      prefillInfo: null,
      forwardedOrDeletedFiles: [], // Forwarded or deleted file info that will pass to next staff
      DOC_FLOW_CANNED_MSG_I18NS,
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      }
    }
  },
  watch: {
  },
  async created () {
    // this.uploadFileUrl = docFlowApi.uploadFileUrl
    this.form.dfProcessId = this.edoc.dfProcessId
    docFlowApi.getProcessPrefillInfo(this.edoc.dfProcessId, resp => {
      this.prefillInfo = resp.data
    })
  },
  methods: {
    /* markAsDeletedFile: function (docCode) {
      let index = 0
      index = this.prefillInfo.fileList.findIndex(obj => obj.docCode === docCode)
      this.prefillInfo.fileList.splice(index, 1)
      this.forwardedOrDeletedFiles.forEach(obj => {
        if (obj.docCode === docCode) {
          obj.actionType = DOC_FLOW_ACTION_TYPE.DELETE
        }
      })
    }, */
    async submit () {
      this.loading = true
      this.form.processAttachmentList = []
      this.form.receiverTOList = []
      this.form.preFilledReceiverTOList = []
      this.form.receiveDate = new Date()

      if (!this.isShowPrivateMsg) {
        this.form.senderNote = null
      }

      this.form.receiverTOList = this.buildStaffList(this.receiverToList)
      this.form.prefilledInstruction = this.prefilledContent.mainContent
      this.form.preFilledReceiverTOList = this.buildStaffList(this.prefilledContent.toStaffs)
      this.form.oriStatusCode = this.edoc.statusCode

      this.attachDocResponse.forEach(attach => {
        this.form.processAttachmentList.push({
          docCode: attach.response,
          docName: attach.name,
          actionType: DOC_FLOW_ACTION_TYPE.ADD,
          id: null
        })
      })
      this.forwardedOrDeletedFiles.forEach(file => {
        this.form.processAttachmentList.push(file)
      })

      if (!this.form.senderInstruction) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('DocFlow.Instruction')]))
        this.loading = false
        return false
      }
      if (this.receiverToList.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eDocSuggest.history.receiver')]))
        this.loading = false
        return false
      }

      if (await this.checkAndShowNoKeyPairUser(this.newOpenersObj)) {
        this.loading = false
        return false
      }

      // console.log('new openers: ' + JSON.stringify(this.buildEncryptedOpenerData(this.newOpenersEuid)))
      if (this.openerList && this.openerList.length && this.newOpenersEuid && this.newOpenersEuid.length) {
        await docFlowApi.addDocumentOpener(this.edoc.dfProcessId, await this.buildEncryptedOpenerData(this.newOpenersEuid), resp => {
          if (resp.status === 201 || resp.status === 200) {
            console.log('add openers successfully')
          } else {
            messageUtil.httpStatusHandler(resp, this)
            this.loading = false
            return false
          }
        })
      }

      docFlowApi.forwardProcess(this.form, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.$emit('closeCard')
          this.clearObjects()
          this.getProcessList(this.onlyShowPrefilled, this.filterText, this.docFlowStatus)
          this.loading = false
          // this.getProcessList()
        } else {
          this.loading = false
        }
      })
    },
    clearObjects () {
      this.$refs.attachUploader.clearFile()
      this.$refs.eDocForm.reset() // reset all input and validation
    },
    clickAgreeInstructionHandler: function () {
      if (this.isAgreeInstruction === true) {
        this.euids = []
        this.form.senderInstruction = null
        if (this.prefillInfo) {
          this.prefillInfo.preFilledReceiverTOList.forEach(obj => {
            if (obj.euid) {
              this.euids.push(obj.euid)
            } else {
              this.euids.push(obj.gid + '') // Integer causes some problems for SSearchStaffMuti
            }
          })
          this.form.senderInstruction = this.prefillInfo.prefilledInstruction
          // this.form.senderNote = this.prefillInfo.prefilledNote
        }
      }
      // else {
      //   this.euids = []
      //   this.form.senderInstruction = null
      // }
    },
    appendMsgToInstructionContent: function (msg) {
      if (this.form.senderInstruction) {
        this.form.senderInstruction += msg
      } else {
        this.form.senderInstruction = msg
      }
    }
  }
}
</script>
